import React, { FC } from 'react';
import { History } from '@mui/icons-material';
import { computeAutomationTooltip } from './utils';

interface AutomationIconProps {
  automationTime?: number | null;
}

export const AutomationIcon: FC<AutomationIconProps> = ({ automationTime }) =>
  automationTime ? (
    <span title={computeAutomationTooltip(automationTime)}>
      <History />
    </span>
  ) : (
    <></>
  );
